import HeroSection from './components/HeroSection';
import StatsBarSection from './components/StatsBarSection';
import SectorsSection from './components/SectorsSection';
import PortfolioPreviewSection from './components/PortfolioPreviewSection';
import WhyUKSection from './components/WhyUKSection';
import InvestorCTASection from './components/InvestorCTASection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <StatsBarSection />
      <SectorsSection />
      <PortfolioPreviewSection />
      <WhyUKSection />
      <InvestorCTASection />
    </main>
  );
}